<div class="rounded-lg border border-neutral-6 bg-neutral-1 p-6">
  <div class="flex items-start gap-4">
    <div class="hidden md:block">
      <mat-icon class="h-12 w-12 text-4xl text-primary-9" fontIcon="assignment"></mat-icon>
    </div>
    <div class="flex flex-1 flex-col gap-4">
      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-2">
          <span class="font-semibold text-neutral-12">Numéro ADEME obligatoire</span>
          <span class="rounded bg-ruby-a2 px-2 py-0.5 text-xs font-medium text-ruby-11 border border-ruby-a5">
            Obligatoire
          </span>
        </div>
        <p class="text-sm text-neutral-10">
          Le numéro ADEME (13 caractères) est obligatoire pour valider un DPE réalisé. Il se trouve en haut à
          droite de votre diagnostic officiel et permet de charger automatiquement toutes les données
          certifiées.
        </p>
      </div>

      <div class="flex flex-col gap-2">
        <div class="flex gap-2">
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>Numéro ADEME</mat-label>
            <input
              matInput
              [formControl]="ademeControl"
              placeholder="1234A1234567B"
              (keyup.enter)="fetchAdemeData()"
              name="ademeNumber"
              required
            />
            <mat-hint>Format : 13 caractères (ex. 1234A1234567B)</mat-hint>
            @if (ademeControl.hasError('required')) {
              <mat-error>Le numéro ADEME est obligatoire</mat-error>
            } @else if (ademeControl.hasError('pattern')) {
              <mat-error>Le format du numéro ADEME est invalide (ex. 1234A1234567B)</mat-error>
            } @else if (ademeControl.hasError('minlength') || ademeControl.hasError('maxlength')) {
              <mat-error>Le numéro ADEME doit contenir exactement 13 caractères</mat-error>
            } @else if (ademeControl.hasError('apiError') || apiError()) {
              <mat-error>{{ apiError() }}</mat-error>
            }
          </mat-form-field>
          <button
            mat-flat-button
            class="primary h-[56px]"
            [disabled]="!ademeControl.value || ademeControl.invalid || isLoading()"
            (click)="fetchAdemeData()"
          >
            @if (isLoading()) {
              Chargement...
            } @else {
              Importer
            }
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
